// Search only the Shopify-provided facet values; product filtering stays server-side.
function connectFacet(facet) {
  const search = facet.querySelector('[data-fp-facet-search]');
  if (!search) return;
  const more = facet.querySelector('[data-fp-facet-more]');
  const empty = facet.querySelector('.fp-facet-empty');
  const list = facet.querySelector('.fp-facet-options');
  const normalise = (text) => text.normalize('NFKD').replace(/\p{M}/gu, '').toLowerCase().trim();
  const options = Array.from(list.querySelectorAll('.fp-facet-option'), (element) => ({
    element,
    input: element.querySelector('input'),
    text: normalise(element.querySelector('.fp-facet-option__text').textContent),
  }));
  let expanded = false;
  function update() {
    const query = normalise(search.value);
    let matches = 0;
    options.forEach((option, index) => {
      const visible = query ? option.text.includes(query) : expanded || index < 10 || option.input.checked;
      option.element.hidden = !visible;
      if (visible) matches++;
    });
    facet.dataset.fpFacetExpanded = String(expanded || !!query);
    more.hidden = !!query;
    more.setAttribute('aria-expanded', String(expanded));
    more.querySelector('[data-fp-facet-more-icon]').textContent = expanded ? '−' : '＋';
    more.querySelector('[data-fp-facet-more-label]').textContent = expanded ? 'Show less' : 'Show more';
    empty.hidden = matches > 0;
    list.scrollTop = 0;
  }
  search.closest('.fp-facet-search').hidden = false;
  search.addEventListener('input', update);
  search.addEventListener('keydown', (event) => {
    if (event.key === 'Enter') event.preventDefault();
    if (event.key === 'Escape' && search.value) {
      event.preventDefault();
      event.stopPropagation();
      search.value = '';
      update();
    }
  });
  more.addEventListener('click', () => { expanded = !expanded; update(); });
  update();
}

function connectCatalog(root = document) {
  root.querySelectorAll('.fp-catalog:not([data-connected])').forEach((catalog) => {
    catalog.dataset.connected = 'true';
    catalog.querySelectorAll('[data-fp-facet]').forEach(connectFacet);
    const filters = catalog.querySelector('.fp-filters');
    const toggle = catalog.querySelector('[data-fp-filter-toggle]');
    const close = catalog.querySelector('[data-fp-filter-close]');
    const wide = matchMedia('(min-width: 768px)');
    function setOpen(open) {
      catalog.classList.toggle('fp-filters-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      document.documentElement.classList.toggle('fp-filter-lock', open);
      if (open) close.focus(); else toggle.focus();
    }
    toggle.addEventListener('click', () => setOpen(true));
    close.addEventListener('click', () => setOpen(false));
    filters.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') setOpen(false);
      if (event.key !== 'Tab' || wide.matches || !catalog.classList.contains('fp-filters-open')) return;
      const stops = Array.from(filters.querySelectorAll('a,button,summary,input:not(:disabled)')).filter(el => !el.closest('[hidden]') && el.getClientRects().length);
      if (event.shiftKey && document.activeElement === stops[0]) { event.preventDefault(); stops.at(-1).focus(); }
      else if (!event.shiftKey && document.activeElement === stops.at(-1)) { event.preventDefault(); stops[0].focus(); }
    });
    wide.addEventListener('change', () => { if (catalog.classList.contains('fp-filters-open')) setOpen(false); });
    const sort = catalog.querySelector('.fp-sort select');
    const sortControl = sort.closest('.fp-sort');
    const syncSortLabel = () => { sortControl.querySelector('[data-fp-sort-value]').textContent = sort.selectedOptions[0].textContent; };
    syncSortLabel();
    sort.addEventListener('pointerdown', () => sortControl.classList.add('fp-sort--pointer'));
    sort.addEventListener('blur', () => sortControl.classList.remove('fp-sort--pointer'));
    sort.addEventListener('keydown', () => sortControl.classList.remove('fp-sort--pointer'));
    const filterForm = sort.form;
    const eventKeys = {'filter.p.m.custom.sample_dispatch_24h':'availability','filter.p.product_type':'category',sort_by:'sort'};
    let changedField;
    filterForm.addEventListener('submit', () => {
      const field = changedField;
      changedField = undefined;
      if (!eventKeys[field]) return;
      const selected = field === 'sort_by' ? 1 : Array.from(filterForm.elements).filter(input => input.name === field && input.checked).length;
      window.FivePointEvents?.emit('fp_filter_apply', {filter_key:eventKeys[field],selected_count:selected}, {source_surface:'catalog',component_id:'catalog-filters'});
    });
    catalog.addEventListener('change', (event) => {
      if (event.target.matches('input[type="checkbox"]') && event.target.form === filterForm) { changedField=event.target.name; filterForm.requestSubmit(); }
    });
    const apply = filterForm.querySelector('.fp-filter-apply');
    if (apply) apply.hidden = true;
    sort.addEventListener('change', () => { syncSortLabel(); changedField=sort.name; sort.form.requestSubmit(); });
    catalog.querySelector('[data-fp-sort-focus]').addEventListener('click', () => {
      catalog.classList.toggle('fp-sort-open');
      if (catalog.classList.contains('fp-sort-open')) sort.focus();
    });
  });
}
connectCatalog();
document.addEventListener('shopify:section:load', (event) => connectCatalog(event.target));
